module.exports = "<p>\r\n  region works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared-components/alliance/region/region.component.html
// module id = ./src/app/shared-components/alliance/region/region.component.html
// module chunks = main